/**
 * Formatting utility functions for the trading dashboard.
 */

const STABLECOIN_MAP = {
  'USDC': 'USD', 'USDT': 'USD', 'DAI': 'USD', 'BUSD': 'USD',
  'TUSD': 'USD', 'GUSD': 'USD', 'USDP': 'USD', 'EURC': 'EUR', 'GBPT': 'GBP'
};

const LOCALE_MAP = {
  'USD': 'en-US', 'GBP': 'en-GB', 'EUR': 'de-DE',
  'JPY': 'ja-JP', 'AUD': 'en-AU', 'CAD': 'en-CA'
};

export const formatCurrency = (amount, portfolioCurrency = 'USD') => {
  let userCurrency = portfolioCurrency || 'USD';
  if (STABLECOIN_MAP[userCurrency]) {
    userCurrency = STABLECOIN_MAP[userCurrency];
  }
  const locale = LOCALE_MAP[userCurrency] || 'en-US';
  const validCurrency = ['USD', 'GBP', 'EUR', 'JPY', 'AUD', 'CAD'].includes(userCurrency) ? userCurrency : 'USD';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: validCurrency }).format(amount);
};

export const formatPercentage = (percent) => {
  const numPercent = parseFloat(percent || 0);
  if (isNaN(numPercent) || !isFinite(numPercent)) return '0.00%';
  return `${numPercent > 0 ? '+' : ''}${numPercent.toFixed(2)}%`;
};

export const formatTimestamp = (timestamp) => {
  return new Date(timestamp).toLocaleString('en-GB');
};

export const formatCooldownTimer = (seconds) => {
  const safeSeconds = Math.max(0, Math.floor(seconds || 0));
  const mm = Math.floor(safeSeconds / 60).toString().padStart(2, '0');
  const ss = (safeSeconds % 60).toString().padStart(2, '0');
  return `${mm}:${ss}`;
};

export const getSignalColor = (signal) => {
  switch(signal) {
    case 'STRONG_BUY': return 'text-green-500';
    case 'BUY': return 'text-green-400';
    case 'HOLD': return 'text-yellow-400';
    case 'SELL': return 'text-red-400';
    case 'STRONG_SELL': return 'text-red-500';
    default: return 'text-gray-400';
  }
};

export const getMarketStatusColor = (strategy) => {
  switch(strategy) {
    case 'active': return 'text-green-400';
    case 'swing': return 'text-blue-400';
    case 'hold': return 'text-gray-400';
    default: return 'text-gray-400';
  }
};
